module.exports = __webpack_public_path__ + "assets/395ec3c6aa9276b08f1475415841370d.png";